import { useCallback } from 'react';
import { useTranslate } from 'react-admin';

import { getErrorMessage } from '@sh4res/bo-common/utils';

export const useArbitrageErrorMessage = (): ((error: unknown) => string) => {
  const translate = useTranslate();

  return useCallback(
    (error: unknown) => {
      const message = getErrorMessage(error);
      return String(
        translate(
          `resources.bo_common.b2b.arbitrage_create.errors.${message.replaceAll('/', '_')}`,
          { _: message },
        ),
      );
    },
    [translate],
  );
};
